// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#furioosPlayer {\r\n  width: 100%;\r\n  aspect-ratio: 16/9;\n}\n.stream {\r\n  width: 100%;\r\n  aspect-ratio: 16/9;\n}\n.errorMessage  {\r\n  border: 1px solid;\r\n  margin: 10px 0px;\r\n  padding: 15px 10px 15px 50px;\r\n  background-repeat: no-repeat;\r\n  background-position: 10px center;\r\n  color: #D8000C;\r\n  background-color: #FFBABA;\r\n  background-image: url('https://i.imgur.com/GnyDvKN.png');\n}\r\n\r\n\r\n", ""]);
// Exports
module.exports = exports;
